require('fullscreenPolyfill')

class window.Header
  constructor: ->
    @mainMenuContainer = $('.main-menu')
    @tabNavigation = $('.tab-window-navigation-js')
    @dropdownListSites = $('.dropdown-list-sites-js')
    @header = $('header')
    @siteMapFlag = false
    @searchFlag = false
    @asideContactsFlag = false
    @linkListShow = false
    @mainMenuSectionLink = $('.main-menu__section:not(.no-child)')
    @windowPosition = 0

    @initHeaderMenuButton()
    @initSitesButton()
    @initHeaderMenu()
    @initSearchBlock()
    @initAsideContacts()


  initHeaderMenuButton: ->
    self = this

    $('.main-menu-button-js').click (event) ->
      $('header').find('.main-menu-button').toggleClass('main-menu-button--active')
      $('#mobileheader').find('.main-menu-button-js').toggleClass('is-active')
      self.toggleSitesLink()
      $(self.mainMenuContainer).toggleClass('main-menu--active')
      $(self.tabNavigation).toggleClass('hidden')

      if !self.siteMapFlag
        self.windowPosition = window.pageYOffset
        $('body').toggleClass('body-overflow');
      else
        $('body').toggleClass('body-overflow');
        $(document).scrollTop(self.windowPosition)

      self.siteMapFlag = !self.siteMapFlag

  toggleInitButton: (menuButton) ->
    $(menuButton).toggleClass('is-active')


  initSitesButton: ->
    self = this
    $('.dropdown-list-sites-js').click (event) ->
      event.preventDefault()
      $(this).toggleClass('dropdown-list-sites--active')
      if self.siteMapFlag == false
        $('body').addClass('body-overflow');

    $('.sites-list__arrow-close-js').click ->
      if self.siteMapFlag == false
        $('body').removeClass('body-overflow');

  initSearchBlock: ->
    $('.js-open-search').click ->
      $('.search-block').addClass('show')
      setTimeout( ->
        self.searchFlag = true
      , 100)

    $('.js-close-search').click ->
      $('.search-block').removeClass('show')
      self.searchFlag = false

    $('.js-open-search-alt').click ->
      $('.search-block').toggleClass('show')
      setTimeout( ->
        self.searchFlag = !self.searchFlag
      , 100)

    $(window).click (event) ->
      if $(event.target).closest('.search-block, .aside-menu__mobile-tools-wrapper').length == 0 && self.searchFlag
        $('.search-block').removeClass('show')
        self.searchFlag = false

  initAsideContacts: ->
    $('.js-open-aside-contacts').click ->
      $('.aside-contacts__hidden-block').addClass('aside-contacts__hidden-block--active')
      setTimeout( ->
        self.asideContactsFlag = true
      , 100)

    $('.js-close-aside-contacts').click ->
      $('.aside-contacts__hidden-block').removeClass('aside-contacts__hidden-block--active')
      self.asideContactsFlag = false

    $(window).click (event) ->
      if $(event.target).closest('.aside-contacts__hidden-block').length == 0 && self.asideContactsFlag
        $('.aside-contacts__hidden-block').removeClass('aside-contacts__hidden-block--active')
        self.asideContactsFlag = false



  launchFullScreen: (element) ->
    element.requestFullscreen()

  launchOffFullScreen: (element) ->
    document.exitFullscreen()

  toggleSitesLink: ->
    self = this

    if self.linkListShow == true
      $(self.dropdownListSites).removeClass('active')
      self.linkListShow = false
    else
      $(self.dropdownListSites).addClass('active')
      self.linkListShow = true


  initHeaderMenu: ->
    self = this

    self.initMobileHeaderMenu()

    $(window).scroll ->
      if $(window).scrollTop() > 48
        $('header').addClass('header--fixed')
      else
        $('header').removeClass('header--fixed')

  initMobileHeaderMenu: ->
    self = this
    self.mainMenuSectionLink.click (event) ->
      if $(window).innerWidth() <= 752
        event.preventDefault()

        $(this).parent(".main-menu__column").toggleClass('active')



// WEBPACK FOOTER //
// ./assets/javascripts/app/header.coffee